<template>
   <div>
      <common-form
         form-title="Demography Information"
         :back-route="backRoute"
         :errors="errors.non_field_errors"
         @submit="save"
         @save-and-continue="saveAndContinue"
      >
         <input-field
            v-model="form.total_pop"
            @input="() => {updateFemalePopulation(); updateHouseholdSize();}"
            type="number" label="Total Population"
            :errors="errors.total_pop" required
         />
         <input-field
            v-model="form.male_pop"
            type="number"
            label="Male Population"
            @input="updateFemalePopulation"
            :errors="errors.male_pop"
            required
         />
         <input-field
            v-model="form.female_pop"
            type="number"
            label="Female Population"
            :errors="errors.female_pop"
            required
         />
         <input-field
            v-model="form.num_household"
            type="number"
            label="Household Number"
            @input="() => {updateHouseholdSize(); updateFemaleHeadedHouseholds()}"
            :errors="errors.num_household"
            required
         />
         <input-field
            v-model="form.male_head_hh"
            type="number"
            label="Male headed household"
            @input="updateFemaleHeadedHouseholds"
            :errors="errors.male_head_hh"
            required
         />
         <input-field
            v-model="form.female_head_hh"
            type="number"
            label="Female headed household"
            :errors="errors.female_head_hh"
            required
         />
         <input-field
            v-model="form.household_size"
            type="number"
            label="Household Size"
            :errors="errors.household_size"
            required
         />
         <!--
         <input-field
            v-model="form.religions"
            placeholder="Type in the religions"
            type="multi-select"
            label="Religion composition"
            :options="religionOptions"
            :errors="errors.religions"
            required
         />
         -->
         <data-table
            title="Religions"
            @add-row="addReligion"
            @edit-row="editReligion"
            @delete-row="deleteReligion"
            :data="form.religions"
            :columnDefs="[
               {label: 'Religion', prop: 'name'},
               {label: 'Percentage', prop: 'percent'},
            ]"
         />
         <data-table
            title="Ethnicities"
            @add-row="addEthnicity"
            @edit-row="editEthnicity"
            @delete-row="deleteEthnicity"
            :data="form.ethnicities"
            :columnDefs="[
               {label: 'Ethnicity', prop: 'name'},
               {label: 'Percentage', prop: 'percent'},
            ]"
         />
      </common-form>
      <religion-form
         v-if="showReligionForm"
         :editing="editingReligion"
         :populate-with="editingReligionIndex!==null ? form.religions[editingReligionIndex] : {}"
         @submit="handleReligionFormSubmit"
         @close="showReligionForm=false"
      />
      <ethnicity-form
         v-if="showEthnicityForm"
         :editing="editingEthnicity"
         :populate-with="editingEthnicityIndex!==null ? form.ethnicities[editingEthnicityIndex] : {}"
         @submit="handleEthnicityFormSubmit"
         @close="showEthnicityForm=false"
      />
   </div>
</template>

<script>
import CommonForm from '@/components/organisms/Home/Plan/Form'
import DataTable from '@/components/organisms/Home/Plan/DataTable';
import InputField from '@/components/molecules/Login/InputField';
import EthnicityForm from '@/components/organisms/Home/Plan/EthnicityForm';
import ReligionForm from '@/components/organisms/Home/Plan/ReligionForm';
import FormMixin from '@/mixins/planform';

export default {
   name: 'demography-form',
   mixins: [FormMixin], 
   components: {
      InputField,
      CommonForm,
      DataTable,
      EthnicityForm,
      ReligionForm,
   },
   data()
   {
      const form = {
         plan: this.getPlanId(),
         total_pop: 0,
         male_pop: 0,
         female_pop: 0,
         pop_below_16: 0,
         pop_16_to_60: 0,
         pop_above_60: 0,
         num_household: 0,
         female_head_hh: 0,
         male_head_hh: 0,
         household_size: 0,
         religions: [],
         ethnicities: [],
      };
      return {
         form,
         errors: this.getDefaultErrors(form),
         backRoute: {name: 'edit-plan',params: {id: this.getPlanId()}},
         nextRoute: {name: 'edit-renewable-energy-info',params: {id: this.getPlanId()}},
         showReligionForm: false,
         editingReligion: false,
         editingReligionIndex: null,
         showEthnicityForm: false,
         editingEthnicity: false,
         editingEthnicityIndex: null,
      };
   },
   computed: {
      url() {
         return `api/plan/${this.getPlanId()}/demography-info`;
      },
      notificationTitle() {
         return 'Demographic Information';
      },
      successMessage() {
         return 'Successfuly edited demographic information'; 
      },
      errorMessage() {
         return "Editing demographic information was unsuccessful";
      },
   },
   methods: {
      updateFemalePopulation() {
         if (!this.form.male_pop || !this.form.total_pop) return;
         this.form.female_pop =  this.form.total_pop - this.form.male_pop;
      },
      updateFemaleHeadedHouseholds() {
         if (!this.form.num_household || !this.form.male_head_hh) return;
         this.form.female_head_hh =  this.form.num_household - this.form.male_head_hh;
      },
      updateHouseholdSize() {
         if (!this.form.num_household || !this.form.total_pop) return;
         this.form.household_size = parseInt(this.form.total_pop/this.form.num_household);
      },
      addReligion() {
         this.editingReligion = false;
         this.showReligionForm = true;
         this.editingReligionIndex = null;
      },
      editReligion(scope) {
         this.editingReligion = true;
         this.showReligionForm = true;
         this.editingReligionIndex = scope.$index;
      },
      deleteReligion(scope) {
         this.form.religions = this.form.religions.filter((_, index) => index!=scope.$index);
      },
      handleReligionFormSubmit({form: formElement, religion: new_data}) {
         if (!formElement.checkValidity()) {
            formElement.reportValidity();
            return;
         }
         if (this.editingReligion) {
            console.assert(this.editingReligionIndex !== null, "Editing religion index can't be null when trying to edit religion");
            const religions = [ ...this.form.religions ];
            religions[this.editingReligionIndex] = new_data;
            this.form.religions = religions;
         }
         else {
            this.form.religions.push(new_data);
         }
         this.showReligionForm = false;
      },
         /* <data-table */
         /*    title="Ethnicities" */
         /*    @add-row="addEthnicity" */
         /*    @edit-row="editEthnicity" */
         /*    @delete-row="deleteEthnicity" */
         /*    :data="form.ethnicities" */
         /*    :columnDefs="[ */
         /*       {label: 'Ethnicity', prop: 'name'}, */
         /*       {label: 'Percentage', prop: 'percent'}, */
         /*    ]" */
         /* /> */
      addEthnicity() {
         this.editingEthnicity = false;
         this.showEthnicityForm = true;
         this.editingEthnicityIndex = null;
      },
      editEthnicity(scope) {
         this.editingEthnicity = true;
         this.showEthnicityForm = true;
         this.editingEthnicityIndex = scope.$index;
      },
      deleteEthnicity(scope) {
         this.form.ethnicities = this.form.ethnicities.filter((_, index) => index!=scope.$index);
      },
      handleEthnicityFormSubmit({form: formElement, ethnicity: new_data}) {
         if (!formElement.checkValidity()) {
            formElement.reportValidity();
            return;
         }
         if (this.editingEthnicity) {
            console.assert(this.editingEthnicityIndex !== null, "Editing ethnicity index can't be null when trying to edit ethnicity");
            const ethnicities = [ ...this.form.ethnicities ];
            ethnicities[this.editingEthnicityIndex] = new_data;
            this.form.ethnicities = ethnicities;
         }
         else {
            this.form.ethnicities.push(new_data);
         }
         this.showEthnicityForm = false;
      },
   },
}
</script>

